import React, { useEffect } from 'react';

interface SEOProps {
  title?: string;
  description?: string;
  keywords?: string;
  image?: string;
  url?: string;
  type?: 'website' | 'article';
  publishedTime?: string;
  modifiedTime?: string;
  author?: string;
  section?: string;
  tags?: string[];
}

const SEO: React.FC<SEOProps> = ({
  title = "Namibia Mining & Energy E-Paper Archive | Mining & Energy News",
  description = "Complete digital archive of Namibia Mining & Energy newspaper editions. Browse historical mining, energy and resources news. Namibia's leading mining and energy publication.",
  keywords = "Namibia mining news, Mining & Energy e-paper, Namibia energy news, mining industry Namibia, energy sector Namibia, resources news, digital newspaper archive",
  image = "https://epaper.miningandenergy.com.na/logo.png",
  url = "https://epaper.miningandenergy.com.na/",
  type = "website",
  publishedTime,
  modifiedTime,
  author = "The Brief",
  section = "Mining & Energy News",
  tags = ["Namibia", "Mining", "Energy", "Resources", "Windhoek"]
}) => {
  useEffect(() => {
    // Update page title for better UX
    document.title = title;
  }, [title]);

  useEffect(() => {
    // Update document title
    document.title = title;
    
    // Update meta tags dynamically
    const updateMetaTag = (name: string, content: string) => {
      let meta = document.querySelector(`meta[name="${name}"]`) as HTMLMetaElement;
      if (!meta) {
        meta = document.createElement('meta');
        meta.name = name;
        document.head.appendChild(meta);
      }
      meta.content = content;
    };
    
    const updatePropertyMetaTag = (property: string, content: string) => {
      let meta = document.querySelector(`meta[property="${property}"]`) as HTMLMetaElement;
      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute('property', property);
        document.head.appendChild(meta);
      }
      meta.content = content;
    };
    
    // Update primary meta tags
    updateMetaTag('description', description);
    updateMetaTag('keywords', keywords);
    updateMetaTag('author', author);
    
    // Update Open Graph tags
    updatePropertyMetaTag('og:title', title);
    updatePropertyMetaTag('og:description', description);
    updatePropertyMetaTag('og:image', image);
    updatePropertyMetaTag('og:url', url);
    updatePropertyMetaTag('og:type', type);
    
    // Update Twitter tags
    updatePropertyMetaTag('twitter:title', title);
    updatePropertyMetaTag('twitter:description', description);
    updatePropertyMetaTag('twitter:image', image);
    updatePropertyMetaTag('twitter:url', url);
    
    // Update canonical URL
    let canonical = document.querySelector('link[rel="canonical"]') as HTMLLinkElement;
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.rel = 'canonical';
      document.head.appendChild(canonical);
    }
    canonical.href = url;
    
  }, [title, description, keywords, author, image, url, type]);
  
  return null; // This component doesn't render anything
};

export default SEO; 